// src/api/setup.ts — 初始化向导 API (Round 10)
//   GET  /api/system-info — 环境检测 (公开)
//   POST /api/setup/init  — 一次性初始化 (节点名称 + 管理员 + 可选下载目录)

import api from './client'

export interface SystemDiskInfo {
  ok: boolean
  path: string
  total: number
  available: number
}

export interface SystemListenInfo {
  host: string
  port: number
  proto: string
}

export interface SystemInfo {
  ok: boolean
  version: string
  commit: string
  build_time: string
  go_version: string
  os: string
  arch: string
  cpu_count: number
  /** 物理内存总字节数 (优先 /proc/meminfo; 降级为 Go runtime Sys) */
  mem_total: number
  mem_sys_mb: number
  disk: SystemDiskInfo
  listen: SystemListenInfo
  node_id: string
  node_name: string
  initialized: boolean
  features: string[]
}

export async function getSystemInfo(): Promise<SystemInfo> {
  return api.get<SystemInfo>('/api/system-info', { skipAuthRedirect: true, silent: true })
}

export interface SetupInitRequest {
  node_name: string
  username: string
  password: string
  download_dir?: string
}

export interface SetupInitResponse {
  ok: boolean
  username: string
  node_name: string
  persisted: boolean
}

export async function postSetupInit(payload: SetupInitRequest): Promise<SetupInitResponse> {
  return api.post<SetupInitResponse>('/api/setup/init', payload, { skipAuthRedirect: true })
}
